// extracted by mini-css-extract-plugin
export default {"container":"V2-z"};